/* PK_TRACK_JS -- Pocketry site activity tracker (owner 2026-10-23: "Everything that can happen on our web site I want recorded
   in the admin somewhere in logs so I can go in and view what any given user did on the site").
   Contract: docs/SITE_ACTIVITY_TRACKING_CONTRACT_2026-10-23.md (identity, POST /api/track/v2, every event name + props).
   Replaces the old snippets/pocketry-journey.liquid on the new site (that file stays in the theme, unused, RULE-14).

   window.pkTrack(name, props) exists from the moment this file runs and always queues; nothing leaves the page until
   (a) the host is pocketry.com / www.pocketry.com, or window.PK_TRACK_FORCE is set (local testing), and
   (b) Shopify's Customer Privacy API allows analytics (same gate as the old snippet; true in the US, no banner).
   Never send typed names, addresses or emails through this: only `filled` and a length. */
(function () {
  if (window.pkTrack && window.pkTrack._pk) return;   // loaded twice (layout asset + an inlined copy): keep the first
  var KEY = 'pocketry_vid', IDLE = 30 * 60 * 1000, MAX_Q = 400, BATCH = 60;
  var host = location.hostname;
  function active() { return host === 'pocketry.com' || host === 'www.pocketry.com' || !!window.PK_TRACK_FORCE; }
  function hex(n) {
    try { return Array.from(crypto.getRandomValues(new Uint8Array(n)), function (b) { return ('0' + b.toString(16)).slice(-2); }).join(''); }
    catch (e) { var s = ''; while (s.length < n * 2) s += Math.floor(Math.random() * 16).toString(16); return s; }
  }
  var vid = null;
  try { vid = localStorage.getItem(KEY); if (!vid || !/^[0-9a-f]{24}$/.test(vid)) { vid = hex(12); localStorage.setItem(KEY, vid); } }
  catch (e) { vid = vid || hex(12); }
  // a visit = this tab session; a new one starts after 30 min with no events
  function visit() {
    var now = Date.now(), v = null, last = 0;
    try { v = sessionStorage.getItem('pk_visit'); last = +sessionStorage.getItem('pk_visit_last') || 0; } catch (e) {}
    if (!v || now - last > IDLE) { v = hex(8); try { sessionStorage.setItem('pk_visit', v); } catch (e) {} }
    try { sessionStorage.setItem('pk_visit_last', String(now)); } catch (e) {}
    return v;
  }
  var visitId = visit();

  function device() {
    var w = Math.min(innerWidth || document.documentElement.clientWidth || (screen && screen.width) || 0, (screen && screen.width) || 9999), touch = false;
    try { touch = matchMedia('(pointer:coarse)').matches || (navigator.maxTouchPoints || 0) > 0; } catch (e) {}
    if (touch && w < 768) return 'mobile';
    if (touch && w < 1300) return 'tablet';
    return w < 600 ? 'mobile' : 'desktop';
  }
  function txt(sel) { var e = document.querySelector(sel); return e ? e.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function kindOf(name, series) {
    var s = (series + ' ' + name).toLowerCase();
    if (/outfit/.test(s)) return 'outfit';
    if (/national park/.test(s)) return 'park';
    if (/\bmap\b/.test(s)) return 'map';
    if (/home|house/.test(s)) return 'home';
    if (/couple|engagement|anniversar|friend|parent/.test(s)) return 'people';
    return 'style';
  }
  // page context: window.PK_PAGE (draft builder config), window.PK_SHOP (Shopify product pages), body class template-*
  function page() {
    var P = window.PK_PAGE || {}, S = window.PK_SHOP || null, bc = (document.body && document.body.className) || '';
    var tm = /(?:^|\s)template-([\w-]+)/.exec(bc), t = tm ? tm[1] : '';
    var type = 'other';
    if (notFound()) type = '404';
    else if (S || P.only === '__product__' || /^product/.test(t)) type = 'product';
    else if (P.info || /^page/.test(t)) type = 'info';
    else if (P.series || /^collection/.test(t)) type = /collection/i.test(P.only || location.pathname) ? 'collection' : 'series';
    else if (P.exclude || /^index/.test(t) || location.pathname === '/') type = 'home';
    else if (/^cart/.test(t)) type = 'cart';
    var out = { type: type, path: location.pathname.slice(0, 300), handle: null, series: null, line: null, kind: null };
    if (type === 'product') {
      var name = txt('.pe-h1'), series = txt('.pe-series');
      try { out.handle = (window.PK_PREVIEW && PK_PREVIEW.handle && PK_PREVIEW.handle()) || null; } catch (e) {}
      if (!out.handle && S) out.handle = S.design || S.handle || null;
      out.series = series || null; out.kind = kindOf(name, series); out.title = name || null;
    } else if (type === 'series' || type === 'collection') {
      out.series = (typeof P.only === 'string' && P.only.indexOf('__') !== 0) ? P.only : (txt('.room-break.head-only .rb-head') || null);
    }
    if (window.PK_LINE) out.line = String(window.PK_LINE);
    return out;
  }
  function notFound() {
    var bc = (document.body && document.body.className) || '';
    return /(?:^|\s)template-404\b/.test(bc) || !!(window.PK_PAGE && window.PK_PAGE.notfound) || /^(404|page not found)/i.test(document.title || '');
  }

  // props: scalars only (strings cut to 300), arrays of up to 10 scalars, at most 24 keys
  function clean(p) {
    var o = {}, n = 0;
    if (!p || typeof p !== 'object') return o;
    for (var k in p) {
      if (!Object.prototype.hasOwnProperty.call(p, k) || n >= 24) continue;
      var v = p[k];
      if (v === undefined || typeof v === 'function') continue;
      if (Array.isArray(v)) v = v.filter(function (x) { return x === null || /^(string|number|boolean)$/.test(typeof x); }).slice(0, 10).map(function (x) { return typeof x === 'string' ? x.slice(0, 300) : x; });
      else if (v !== null && typeof v === 'object') continue;
      else if (typeof v === 'string') v = v.slice(0, 300);
      else if (typeof v === 'number' && !isFinite(v)) continue;
      o[k] = v; n++;
    }
    return o;
  }

  var q = [], seq = 0, timer = null, allowed = false, t0 = Date.now();
  function api() {
    var b = typeof window.PK_TRACK_API === 'string' ? window.PK_TRACK_API : typeof window.PK_API === 'string' ? window.PK_API : 'https://app.pocketry.com';
    return b.replace(/\/$/, '') + '/api/track/v2';
  }
  function send(body) {
    var url = api();
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(url, new Blob([body], { type: 'text/plain' }))) return;
    } catch (e) {}
    try { fetch(url, { method: 'POST', body: body, headers: { 'Content-Type': 'text/plain' }, keepalive: true, credentials: 'omit', mode: 'cors' }).catch(function () {}); } catch (e) {}
  }
  function flush() {
    if (timer) { clearTimeout(timer); timer = null; }
    if (!allowed || !active() || !q.length) return;
    if (document.readyState === 'loading') { schedule(); return; }   // page context (PK_PAGE, product name) isn't in the DOM yet
    var pg = page(), dev = device();
    while (q.length) {
      var body = { vid: vid, visit: visitId, page: pg, device: dev, events: q.splice(0, BATCH) };
      if (window.PK_TRACK_DEBUG) try { console.info('[pkTrack]', body); } catch (e) {}
      send(JSON.stringify(body));
    }
  }
  function schedule() { if (!timer) timer = setTimeout(flush, 2500); }
  function pkTrack(name, props) {
    try {
      if (!name) return;
      visitId = visit();
      if (q.length >= MAX_Q) q.shift();
      q.push({ n: String(name).slice(0, 64), t: Date.now(), s: ++seq, p: clean(props) });
      if (q.length >= 20) flush(); else schedule();
    } catch (e) {}
  }
  pkTrack._pk = true;
  pkTrack.flush = flush;
  pkTrack.vid = function () { return vid; };
  pkTrack.queue = function () { return q.slice(); };
  window.pkTrack = pkTrack;
  window.PK_VID = vid;

  // ---- page_view (first event of the page) ----
  (function () {
    var p = { referrer: (document.referrer || '').slice(0, 300), w: innerWidth || (screen && screen.width) || null, h: innerHeight || (screen && screen.height) || null };
    try {
      var s = new URLSearchParams(location.search);
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) { var v = s.get(k); if (v) p[k] = v.slice(0, 120); });
      ['gclid', 'fbclid', 'ttclid', 'gbraid', 'wbraid'].forEach(function (k) { if (s.get(k)) p[k] = true; });
      ['tile', 'opt', 'pets'].forEach(function (k) { var v = s.get(k); if (v) p[k] = v.slice(0, 120); });
      if (s.get('portrait')) p.portrait = true;   // emailed "come back to it" link (the token itself is never sent)
    } catch (e) {}
    pkTrack('page_view', p);
  })();

  function onReady() {
    if (notFound()) pkTrack('page_not_found', { path: (location.pathname + location.search).slice(0, 300) });
    // ---- scroll_depth + page_leave ----
    var maxPct = 0, sent = {}, left = false, ticking = false;
    function pct() { var h = document.documentElement, total = Math.max(1, (h.scrollHeight || 1) - innerHeight); return Math.max(0, Math.min(100, Math.round(((scrollY || h.scrollTop || 0) / total) * 100))); }
    function measure() { ticking = false; var p = pct(); if (p > maxPct) maxPct = p;
      [25, 50, 75, 100].forEach(function (m) { if (p >= m && !sent[m]) { sent[m] = true; pkTrack('scroll_depth', { pct: m }); } }); }
    function onScroll() { if (ticking) return; ticking = true; setTimeout(measure, 200); }
    addEventListener('scroll', onScroll, { passive: true }); setTimeout(onScroll, 1500); setInterval(measure, 1000);
    function leave() { if (left) return; left = true; var p = pct(); if (p > maxPct) maxPct = p;
      pkTrack('page_leave', { secs: Math.round((Date.now() - t0) / 1000), scroll_pct: maxPct }); flush(); }
    addEventListener('pagehide', leave);
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') leave(); else left = false; });

    // ---- delegated clicks: menus, footer, social, breadcrumbs, tiles, See-all, info links, support email ----
    function label(el) { var t = (el.getAttribute('aria-label') || el.textContent || '').replace(/\s+/g, ' ').trim(); return t.slice(0, 80); }
    function hrefOf(a) { var h = a.getAttribute('href') || ''; return h.slice(0, 300); }
    function qp(h, k) { try { return new URL(h, location.href).searchParams.get(k); } catch (e) { return null; } }
    document.addEventListener('click', function (e) {
      var el = e.target && e.target.closest ? e.target : null; if (!el) return;
      var a = el.closest('a');
      if (a) {
        var h = hrefOf(a);
        if (/^mailto:/i.test(h)) {
          var ctx = a.closest('.site-footer') ? 'footer' : a.closest('#pe-mine') ? 'preview_card' : a.closest('#pk-pv') ? 'preview_popup' : a.closest('.pe-small') ? 'product_page' : a.closest('.pdp') ? 'product_page' : 'other';
          return pkTrack('support_email_click', { context: ctx });
        }
        if (a.closest('#pk-nav')) return pkTrack('nav_click', { label: label(a), href: h, area: a.closest('.sub') ? 'dropdown' : 'header' });
        if (a.closest('#pk-mnav')) return pkTrack('nav_click', { label: label(a), href: h, area: 'mobile_menu' });
        if (a.closest('.pocketry-social-strip')) return pkTrack('nav_click', { label: label(a), href: h, area: 'social' });
        if (a.closest('.site-footer')) return pkTrack('nav_click', { label: label(a), href: h, area: 'footer' });
        if (a.closest('.crumbs')) return pkTrack('nav_click', { label: label(a), href: h, area: 'breadcrumb' });
        if (a.closest('.shopify-style-header') && !a.closest('nav[aria-label="Shopping cart"]')) return pkTrack('nav_click', { label: label(a) || 'logo', href: h, area: 'header' });
        if (a.classList.contains('tile-link')) {
          var fig = a.closest('figure'), all = Array.prototype.slice.call(document.querySelectorAll('figure.tile.has-link'));
          var sec = a.closest('section'), head = sec && sec.classList.contains('pk-more') ? 'explore' : a.closest('#out') ? 'rows' : 'other';
          return pkTrack('tile_click', { product: a.getAttribute('aria-label') || '', series: fig && fig.querySelector('.ds') ? fig.querySelector('.ds').textContent.trim() : '',
            tile: qp(h, 'tile'), opt: qp(h, 'opt'), pets: qp(h, 'pets'), position: all.indexOf(fig) + 1, section: head });
        }
        if (a.closest('.see-link')) { var m = /\/collections\/([\w-]+)|([\w-]+-(?:series|collection))\.html/.exec(h); return pkTrack('see_all_click', { series: m ? (m[1] || m[2]) : label(a), label: label(a) }); }
        if (a.classList.contains('pk-rel')) { var m2 = /\/collections\/([\w-]+)|([\w-]+-(?:series|collection))\.html/.exec(h); return pkTrack('see_all_click', { series: m2 ? (m2[1] || m2[2]) : '', label: label(a), from: 'related' }); }
        if (/\/pages\//.test(h) || a.classList.contains('pk-info-btn')) return pkTrack('info_link_click', { target: h, label: label(a) });
      }
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onReady); else onReady();

  // ---- consent gate (same logic as the old pocketry-journey snippet) ----
  function consentOk() { try { var cp = window.Shopify && window.Shopify.customerPrivacy; return cp && typeof cp.analyticsProcessingAllowed === 'function' ? cp.analyticsProcessingAllowed() : null; } catch (e) { return null; } }
  function start() { if (allowed) return; allowed = true; flush(); }
  function init() {
    if (window.PK_TRACK_FORCE) return start();
    if (!active()) return;
    var ok = consentOk();
    if (ok === true) return start();
    if (ok === null && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (!err && consentOk() === true) start(); });
    }
  }
  document.addEventListener('visitorConsentCollected', function (e) {
    var d = (e && e.detail) || {};
    pkTrack('cookie_consent', { analytics: !!d.analyticsAllowed, marketing: !!d.marketingAllowed });
    if (consentOk() === true || d.analyticsAllowed) start();
  });
  // PK_TRACK_FORCE may be set from the console after load: re-check once the page is up
  if (document.readyState === 'complete') init(); else { addEventListener('load', init); if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init(); }
  pkTrack.start = function () { window.PK_TRACK_FORCE = true; start(); };
})();
